import React from 'react';
import Img from 'gatsby-image';
import { StaticQuery, graphql } from 'gatsby';

function renderImage(file) {
  console.log('file is', file)
  return (
    <Img
      fluid={file.node.childImageSharp.fluid}
      imgStyle={{objectFit: 'contain'}}
      style={{height: '100%'}}
    />
  )
}

const ModalImg = function (props) {

  return <StaticQuery
    query={graphql`
    query {
      images: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "photos"}}) {
        edges {
          node {
            name
            extension
            relativePath
            childImageSharp {
            fluid(maxWidth: 6400) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
    `}
    render={(data) => {
      console.log(data.images.edges[0].node)
      const image = data.images.edges.find(
        image => {
          console.log(image)
          return image.node.name === props.image
        }
      )
      return(renderImage(image))
    }}
  />
}

export default ModalImg;